import React from 'react';
import apiURL from '../hooks/useAPI';

const CarDirectorioDetalle = ({ data }) => {
    const { fotoAPI } = apiURL;
    const fotoDefecto = `${fotoAPI}static/usrs/nouser.png`;

    let Error_Cargar = (e) => {
        e.target.setAttribute("src", fotoDefecto);
    }

    // Quita acentos y normaliza para construir el correo institucional
    const limpiar = (s) =>
        String(s || "")
            .normalize("NFD")
            .replace(/[̀-ͯ]/g, "")
            .toLowerCase()
            .replace(/[^a-z]/g, "");

    // Correo institucional: primera letra del nombre + apellido + @esen.edu.sv
    const construirCorreo = (nombre) => {
        const tokens = String(nombre || "").trim().split(/\s+/).filter(Boolean);
        if (tokens.length < 2) return null;
        const inicial = limpiar(tokens[0]).charAt(0);
        const apellido = limpiar(tokens[tokens.length - 1]);
        if (!inicial || !apellido) return null;
        return `${inicial}${apellido}@esen.edu.sv`;
    };

    const goUp = document.getElementById('content');
    let upGo = () => {
        if (goUp) goUp.scrollIntoView({ behavior: 'smooth' });
    }

    return (
        data.map((elemento, index) => {
            const { codigo, nombre, cargo, correo } = elemento;
            const userFoto = codigo ? `${fotoAPI}static/usrs/${codigo}.jpg` : fotoDefecto;
            const email = correo || construirCorreo(nombre);
            return (
                <div key={codigo || nombre || index} className="col-12 col-sm-6 col-lg-4 mb-3 d-flex">
                    <div className="card text-center w-100">
                        <div className="card-body d-flex flex-column">
                            <img
                                src={userFoto}
                                className="rounded mx-auto d-block w-50 mb-3"
                                alt={nombre}
                                onError={Error_Cargar}
                            />
                            <h5 className="card-title mb-1">{nombre}</h5>
                            <p className="card-text text-muted small mb-3">{cargo}</p>
                            <div className="mt-auto d-flex align-items-center justify-content-center">
                                {email ? (
                                    <a
                                        href={`mailto:${email}`}
                                        className="btn btn-outline-primary btn-sm mr-2 text-truncate"
                                    >
                                        <i className="fa fa-envelope-o mr-1" aria-hidden="true"></i>
                                        {email}
                                    </a>
                                ) : null}
                                <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm goUP"
                                    onClick={upGo}
                                    title="Volver arriba"
                                >
                                    <i className="fa fa-arrow-up" aria-hidden="true"></i>
                                    <span className="sr-only">Volver arriba</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    )
}

export default CarDirectorioDetalle;
